import { cn } from '@/lib/cn';

interface BraindayMarkProps {
  size?: number;
  className?: string;
}

export function BraindayMark({ size = 30, className }: BraindayMarkProps) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      aria-hidden
      className={cn('text-t1', className)}
    >
      {/* Theme-adaptive: the tile follows currentColor (t1 → near-black in light,
          near-white in dark), the two muted bars use the canvas so they contrast
          against the tile in both themes, and the accent bar tracks the brand
          indigo per theme. Previously hardcoded hex → invisible in dark mode. */}
      <rect x="0" y="0" width="64" height="64" rx="14" fill="currentColor" />
      <rect x="14" y="18" width="36" height="6" rx="3" fill="var(--canvas)" opacity="0.32" />
      <rect x="14" y="29" width="28" height="6" rx="3" fill="var(--brand)" />
      <rect x="14" y="40" width="22" height="6" rx="3" fill="var(--canvas)" opacity="0.32" />
    </svg>
  );
}
